import xss from 'xss'

function getClassName(tag: string) {
  switch (tag) {
    case 'table':
      return 'govuk-table'
    case 'caption':
      return 'govuk-table__caption'
    case 'thead':
      return 'govuk-table__head'
    case 'tr':
      return 'govuk-table__row'
    case 'th':
      return 'govuk-table__header'
    case 'tbody':
      return 'govuk-table__body'
    case 'td':
      return 'govuk-table__cell'
    case 'p':
      return 'govuk-body'
    case 'ul':
      return 'govuk-list govuk-list--bullet'
    case 'ol':
      return 'govuk-list govuk-list--number'
    case 'li':
      return 'govuk-body'
    default:
      return ''
  }
}

export const richTextToGovukHtml = (html: string, ...extraClasses: string[]) =>
  xss(html, {
    onTag: (tag, html, options) => {
      const className = getClassName(tag) ? ` class="${getClassName(tag)} ${extraClasses.join(' ')}"` : ''
      const tagWithClassName = tag + className
      const editedHtml = !options.isClosing ? html.replace(tag, tagWithClassName) : html

      return editedHtml
    },
  })
